import { useMutation } from "@tanstack/react-query";
import { trainingMonthlyPlanApi } from "../../../../../services/human-organization/training-course-monthly.service";

export const useUpdateMTP = () => {
  return useMutation({
    mutationFn: ({ id, body }: any) => {
      const updatedFields = trainingMonthlyPlanApi.toRequest(body);
      return trainingMonthlyPlanApi.update(id, updatedFields);
    },
  });
};
